import { WriterTable } from './WriterTable'
import { withWriterTable } from './withWriterTable'

const ConnectedWriterTable = withWriterTable(WriterTable)
export { ConnectedWriterTable as WriterTable }
